import { render, staticRenderFns } from "./rolesProfile.vue?vue&type=template&id=f01a99e8&scoped=true"
import script from "./rolesProfile.vue?vue&type=script&lang=js"
export * from "./rolesProfile.vue?vue&type=script&lang=js"
import style0 from "./rolesProfile.vue?vue&type=style&index=0&id=f01a99e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a99e8",
  null
  
)

export default component.exports